import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { BookingListItemDto } from 'models/bookappointment';
import { PersonItem } from 'components';
import moment = require('moment');
import { formatCurrency, formatDuration } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';

interface IProps {
	t?: (key: string) => string;
	bookingItem: BookingListItemDto;
	staffById: any;
	servicesById: any;
}

interface IState {
	isActive: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ResourceDetails extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {
			isActive: false,
		};
	}

	private renderResource = (
		item: BookingListItemDto,
		i: number,
		isFromBundle: boolean,
		bundleService?: BookingListItemDto,
	): JSX.Element => {
		const { staffById, servicesById } = this.props;
		let service = null;

		const subServiceSum = bundleService?.childrenBookings?.reduce((prev, curr) => prev + curr.price, 0);
		const itemPrice =
			isFromBundle && subServiceSum != 0 ? (item.price / subServiceSum) * bundleService.price : item.price;

		if (isFromBundle) {
			service = servicesById[`${bundleService.bookingTemplateId}:${item.bookingTemplateId}`]; // Object key is bundle booking template id : children booking template id
		} else {
			service = servicesById[item.bookingTemplateId];
		}

		const details: JSX.Element[] = [];
		const currencyKey = item.shopCurrencyKey;

		if (item.schedule) {
			const start = moment(item.schedule);
			if (service) {
				details.push(
					<span
						className="bookingAppointment__scheduleStep__resourceContainer__serviceDetails__duration"
						key={service.id + service.duration}
					>
						{formatDuration(service.duration)}
					</span>,
				);
			} else {
				details.push(
					<span
						className="bookingAppointment__scheduleStep__resourceContainer__serviceDetails__duration"
						key={item.id + item.duration}
					>
						{start.format('LT')}
					</span>,
				);
			}
		}
		details.push(
			<span
				className="bookingAppointment__scheduleStep__resourceContainer__serviceDetails__price"
				key={item.id + itemPrice}
			>
				{formatCurrency(currencyKey, itemPrice || null)}
			</span>,
		);
		let resourceEl: JSX.Element = null;

		// todo: compare with currentFormValues, if not null pazi
		if (item.resourceId && staffById[item.resourceId]) {
			resourceEl = <PersonItem user={staffById[item.resourceId]} shortenName={true} key={staffById[item.resourceId]} />;
		}

		return (
			<div
				className={`${this.props?.bookingItem?.availableBookings.length > 1 ? 'col-md-6' : 'col-md-12'}`}
				key={item.id}
			>
				<div className="bookingAppointment__scheduleStep__resourceContainer" key={item.id || i}>
					<p className="bookingAppointment__scheduleStep__resourceContainer__serviceFullName">
						{service?.fullName || item.name}
					</p>
					{resourceEl}
					<div className="bookingAppointment__scheduleStep__resourceContainer__serviceDetails">{details}</div>
				</div>
			</div>
		);
	};

	private handleClick = (event) => {
		event.stopPropagation();

		this.setState({ isActive: !this.state.isActive });
	};

	render() {
		const { bookingItem, t } = this.props;

		const resourceParts: JSX.Element[] = [];
		bookingItem.availableBookings?.map((ab, idx) => {
			if (ab?.childrenBookings?.length > 0) {
				ab.childrenBookings.map((cbt) => {
					resourceParts.push(this.renderResource(cbt, idx, true, ab));
				});
			} else {
				resourceParts.push(this.renderResource(ab, idx, false));
			}
		});

		return (
			<>
				<div className="row">
					<div className="col-12">
						<div className="bookingAppointment__scheduleStep__detailsSwitch" onClick={(e) => this.handleClick(e)}>
							<span>{t('Shop_Appointments_Details_Title')}</span>
							{this.state.isActive ? renderIcon('arrow_left') : renderIcon('arrow_right')}
						</div>
					</div>
				</div>
				<div className="row bookingAppointment__scheduleStep__detailsRow">
					{this.state.isActive ? resourceParts : null}
				</div>
			</>
		);
	}
}

export default ResourceDetails;
